import { render, staticRenderFns } from "./ProductList.vue?vue&type=template&id=0bd73a8a"
import script from "./ProductList.vue?vue&type=script&lang=js"
export * from "./ProductList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {FilterList: require('/app/components/FilterList.vue').default,FilterModal: require('/app/components/FilterModal.vue').default,ProductListToolbar: require('/app/components/ProductListToolbar.vue').default,Loading: require('/app/components/Loading.vue').default,CategoryStructuredData: require('/app/components/CategoryStructuredData.vue').default,ProductListItem: require('/app/components/ProductListItem.vue').default})
